
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function OrderForm() {
  const navigate = useNavigate();

  const [items, setItems] = useState([
    { quantity: 2, unit: "kg", product: "Avocado" },
  ]);

  const quantities = Array.from({ length: 20 }, (_, i) => i + 1);
  const units = ["kg", "g", "box"];
  const products = ["Avocado", "Tomato", "Orange", "Onion"];

  const updateItem = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const addItem = () => {
    setItems([...items, { quantity: 1, unit: "kg", product: "" }]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 via-green-100 to-green-700 flex flex-col   px-4">
      {/* back button */}
      <div className="p-6">
        <button
          className="flex items-center gap-2 text-gray-800 font-medium hover:gap-3 transition-all"
          onClick={() => navigate("/get-started")}
        >
          <ArrowLeft size={20} />
          <span className="text-lg">Back</span>
        </button>
      </div>
      <div className="items-center justify-center flex flex-col">
        <div className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-md md:max-w-lg mt-12 mb-16 items-center">
          <div className="px-6 py-10 space-y-8">
            {/* ORDER ITEMS */}
            <div className="">
              <h3 className="font-semibold text-lg mb-4">
                What would you like to order?
              </h3>

              <div className="space-y-4">
                {items.map((item, index) => (
                  <div key={index} className="grid grid-cols-3 gap-3">
                    <select
                      value={item.quantity}
                      onChange={(e) =>
                        updateItem(index, "quantity", e.target.value)
                      }
                      className="border rounded-md px-3 py-2 bg-white"
                    >
                      {quantities.map((q) => (
                        <option key={q} value={q}>
                          {q}
                        </option>
                      ))}
                    </select>

                    <select
                      value={item.unit}
                      onChange={(e) =>
                        updateItem(index, "unit", e.target.value)
                      }
                      className="border rounded-md px-3 py-2 bg-white"
                    >
                      {units.map((unit) => (
                        <option key={unit} value={unit}>
                          {unit}
                        </option>
                      ))}
                    </select>

                    <select
                      value={item.product}
                      onChange={(e) =>
                        updateItem(index, "product", e.target.value)
                      }
                      className="border rounded-md px-3 py-2 bg-white"
                    >
                      <option value="">Select item</option>
                      {products.map((product) => (
                        <option key={product} value={product}>
                          {product}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>

              <button
                onClick={addItem}
                className="w-full mt-6 bg-[#194E20] text-white py-3 rounded-md shadow-md"
              >
                + Add Another Item
              </button>
            </div>

            {/* FREE TEXT ORDER */}
            <div>
              <p className="font-medium mb-2">Or write your order here:</p>
              <textarea
                className="w-full border rounded-md px-3 py-2 min-h-[80px]"
                placeholder="e.g. I want 5kg avocados, 2 melons..."
              />
            </div>

            {/* NOTES */}
            <div>
              <p className="font-medium mb-2">Additional Notes</p>
              <textarea
                className="w-full border rounded-md px-3 py-2 min-h-[80px]"
                placeholder="Any special requests or notes..."
              />
            </div>

            {/* COLLECTION TIME */}
            <div>
              <p className="font-medium mb-2">When can you collect?</p>
              <input
                className="w-full border rounded-md px-3 py-2"
                placeholder="What days/times are you available"
              />
            </div>

            {/* DELIVERY OPTIONS */}
            <div>
              <p className="font-medium mb-3">Collection & Delivery</p>
              <div className="space-y-2 text-sm">
                {[
                  "I’d like to pick my own if possible",
                  "I can collect from the farm",
                  "I’d like delivery if possible",
                  "I’ll collect if delivery isn’t available",
                ].map((label) => (
                  <label key={label} className="flex items-center gap-2">
                    <input type="checkbox" />
                    {label}
                  </label>
                ))}
              </div>
            </div>

            {/* LOCATION */}
            <div>
              <p className="font-medium mb-2">Your Location</p>
              <input
                className="w-full border rounded-md px-3 py-2"
                placeholder="Nejra, Maro, Malaga, etc."
              />
            </div>

            {/* CONTACT */}
            <div>
              <p className="font-medium mb-2">Your Contact Details</p>
              <div className="space-y-3">
                <input
                  className="w-full border rounded-md px-3 py-2"
                  placeholder="Your email address"
                />
                <input
                  className="w-full border rounded-md px-3 py-2"
                  placeholder="Your phone number"
                />
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" />I use WhatsApp
                </label>
              </div>
            </div>

            {/* SUBMIT */}
            <button className="w-full bg-black text-white py-3 rounded-md shadow-lg">
              Send Order
            </button>
          </div>
        </div>
        {/* Footer */}
        <footer className="px-6 py-6 text-center">
          <p className="text-white text-sm">
            Copyright © 2025 AADA. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
}


